export const FETCH_ALL_DATA_BEGIN= 'FETCH_ALL_DATA_BEGIN';
export const FETCH_ALL_DATA_SUCCESS='FETCH_ALL_DATA_SUCCESS';
export const FETCH_ALL_DATA_ERROR='FETCH_ALL_DATA_ERROR';

